import {MultiFanCoordinates} from "./multiFanNoise";
import {RequiredVisibilityRect} from "./RequiredVisibilityRect";

/**
 * Punkt obserwacyjny - miejsce gdzie mierzymy hałas
 */
export class Observer {
    constructor(readonly position: MultiFanCoordinates) {
    }

    getRequiredVisibilityRect(): RequiredVisibilityRect {
        const margin = 5; // Małą marginesem dla kropki
        return new RequiredVisibilityRect(
            this.position.xMeters - margin,
            this.position.yMeters - margin,
            this.position.xMeters + margin,
            this.position.yMeters + margin
        );
    }

    renderToSVG(svgScale: number): string {
        const scaledX = this.position.xMeters * svgScale;
        const scaledY = this.position.yMeters * svgScale;
        const observerRadius = Math.max(0.15 * svgScale, 0.5); // Skalowana kropka obserwatora

        return `
            <g>
                <circle cx="${scaledX}" cy="${scaledY}" r="${observerRadius}" fill="#000000" />
            </g>
        `;
    }
}